import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "row pb-2 text-center"
};
const _hoisted_2 = {
  class: "col-12 text-center"
};
const _hoisted_3 = {
  class: "image-container"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "button-group"
};
const _hoisted_6 = {
  class: "button-group mt-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_likeunlike = _resolveComponent("likeunlike");
  const _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: $props.previewImg,
    class: "mt-2 img-fluid",
    style: {
      "width": "90%"
    }
  }, null, 8, _hoisted_4)]), _createVNode(_component_likeunlike, {
    imginfo: $props.currentimgInfo,
    onOnClicklike: $options.onClicklike
  }, null, 8, ["imginfo", "onOnClicklike"]), _createElementVNode("div", _hoisted_5, [$data.pageshow ? (_openBlock(), _createBlock(_component_van_button, {
    key: 0,
    plain: "",
    type: "primary",
    onClick: $options.onDownload
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("下载ldr模型")])),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true), $data.pageshow ? (_openBlock(), _createBlock(_component_van_button, {
    key: 1,
    plain: "",
    type: "primary",
    onClick: $options.onDownloadImage
  }, {
    default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("下载高清生成图")])),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true), $data.pageshow ? (_openBlock(), _createBlock(_component_van_button, {
    key: 2,
    plain: "",
    type: "primary",
    onClick: $options.onDownloadJSON
  }, {
    default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("下载拼装json")])),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [$data.pageshow ? (_openBlock(), _createBlock(_component_van_button, {
    key: 0,
    plain: "",
    type: "primary",
    onClick: $options.onReleaseInHomePage,
    loading: $data.isReleasing,
    disabled: $data.isReleasing
  }, {
    default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("发布为首页滚动图")])),
    _: 1
  }, 8, ["onClick", "loading", "disabled"])) : _createCommentVNode("", true), $data.pageshow ? (_openBlock(), _createBlock(_component_van_button, {
    key: 1,
    plain: "",
    type: "primary",
    onClick: $options.onDeletInHomePage,
    loading: $data.isDeleting,
    disabled: $data.isDeleting
  }, {
    default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("从首页删除")])),
    _: 1
  }, 8, ["onClick", "loading", "disabled"])) : _createCommentVNode("", true)])])]);
}